import {Component} from '@angular/core';

@Component({
    selector: 'course-students-support-article',
    template: ``
})
export class StudentsSupportArticleComponent {
}
